import { DateTime } from "luxon";
import { BookingScheduleInterface } from "../../../../../features/Booking-Form/typings/booking.types";
import { UserInformation } from "../../../../../features/Login/typings/login.types";
import { Colleague } from "../../../../../features/Connections/types/Colleague.type";
import { BookingType } from "../../../../../features/Booking-Form/typings/booking-inputs";
import { NoPlaceZoneBooking } from "../../../../../features/Booking-Form/typings/booking-service-administration.types";

// Helper function to check if schedule is of type NoPlaceZoneBooking
function isNoPlaceZoneBooking(schedule: any): schedule is NoPlaceZoneBooking {
  return (schedule as NoPlaceZoneBooking)?.serviceBookings !== undefined;
}

export function generateScheduleType({
  schedule,
  userInformation,
  remoteColleagues
}: {
  schedule: BookingScheduleInterface;
  userInformation: UserInformation;
  remoteColleagues: Colleague[] | undefined;
}) {
  const isUpcomingSchedule =
    DateTime.fromISO(schedule.startDate).valueOf() > DateTime.now().valueOf();

  /** user's schedule is deletable */
  const isUserScheduleDeletable =
    isUpcomingSchedule && schedule.userBookedFor === userInformation.sub && !schedule.isGuest;

  /** schedule user's booking connect status */
  const isScheduleColleaguesCancelAllow =
    remoteColleagues?.find(col => col.userId === schedule.userBookedFor)?.teamBookingColleague ?? // previously teamBookingPermission
    false;

  /** colleague's schedule is editable/deletable by company setting and connections */
  const isColleagueScheduleEditable =
    isUpcomingSchedule &&
    schedule.userBookedFor !== userInformation.sub &&
    userInformation.company.meta.allowBookingCancellations &&
    isScheduleColleaguesCancelAllow;

  const checkBookingTypeZone =
    schedule.bookingType === BookingType.PLACEZONE ||
    schedule.bookingType === BookingType.CONFERENCEZONE;
  /** show conference booking service when the value exists */
  const isConferenceZoneBooking =
    schedule.bookingType === BookingType.CONFERENCEZONE &&
    userInformation.company.meta.activateBookingServices &&
    isNoPlaceZoneBooking(schedule); // Check if schedule is of type NoPlaceZoneBooking

  return {
    isUserScheduleDeletable,
    isColleagueScheduleEditable,
    checkBookingTypeZone,
    isConferenceZoneBooking
  };
}
